import { Box, Typography } from "@mui/material"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import { useQuestionnaireContext } from "../../contextProvider"
import { SectionProvider } from "./contextProvider/provider"
import { SectionForm } from "./sectionForm"
import { useStyles } from "./styles"
import SimpleButtons from "../../../../../../components/buttons/simples"
import { DragAndDrop } from "../../../../../../components/dragAndDrop"
import { SectionDefault } from "../../contextProvider/provider/types"
import { useTranslation } from "react-i18next"
import { LoadingButton } from "@mui/lab"

const Section = () => {
    const {
        dataHeader,
        totalPoints,
        isGeneral,
        headerConfig,
        loadings,
        sectionTotalPoints,
        sectionAmount,
        handleTotalPoints,
        setModal,
        closeModal,
        setIdSectionIsEditing,
        sectionList,
        optionGroup,
        options,
        sectionRef,
        averagePoints,
        questionTotal,
        updateQuestionList,
        sectionError,
        updateSectionData,
        totalSectionPoints,
        setTotalSectionPoints,
        isSectionConfig, orderSection, addSection, removeSection, createQuestionnaire } = useQuestionnaireContext()
    const styles = useStyles()
    const sectinListLength = sectionList.length
    const { t } = useTranslation()

    return (
        <Box >
            <Box sx={styles.tag}>
                <Typography>{t('general.structure')}</Typography>
            </Box>
            <Box sx={styles.sectionList}>

                <Box sx={{
                    width: '100%',
                    // maxHeight: 'calc(100vh - 360px)',
                    overflow: 'auto',
                }}>
                    <CustomPaper sx={styles.container} elevation={1}>
                        <DragAndDrop
                            list={sectionList}
                            newOrder={orderSection}
                            model={({ item: section, provided, index }) => (
                                <div style={{ ...provided.draggableProps.style, width: '100%' }} ref={provided.innerRef} {...provided.draggableProps} key={section.id}>
                                    <SectionProvider
                                        updateQuestionList={updateQuestionList}
                                        optionGroup={optionGroup}
                                        options={options}
                                        setTotalSectionPoints={setTotalSectionPoints}
                                        totalSectionPoints={totalSectionPoints}
                                        index={index}
                                        totalSection={(section as SectionDefault)?.totalSection ?? 0}
                                        sectionDefault={(section as SectionDefault)?.sectionDefault}
                                        questionListDefault={(section as SectionDefault)?.questionListDefault}
                                        id={section.id}
                                        key={section.id}
                                        averagePoints={averagePoints}
                                        headerConfig={headerConfig}
                                        isGeneral={isGeneral}
                                        isSectionConfig={isSectionConfig}
                                        totalPoints={totalPoints}
                                        dataHeader={dataHeader}
                                        closeModal={closeModal}
                                        sectionAmount={sectionAmount}
                                        sectionTotalPoints={sectionTotalPoints}
                                        setIdSectionIsEditing={setIdSectionIsEditing}
                                        setModal={setModal}
                                        handleTotalPoints={handleTotalPoints}
                                    >
                                        <SectionForm sectionError={sectionError?.[index]} sectionDefault={(section as SectionDefault)?.sectionDefault} updateSectionData={updateSectionData} questionListDefault={(section as SectionDefault)?.questionListDefault} provided={provided} isSectionConfig={isSectionConfig} questionAmount={questionTotal ?? 0} totalPoints={isSectionConfig ? (averagePoints / sectinListLength) : averagePoints} ref={element => sectionRef.addRef({ element, name: section.id })} sectionAmount={sectinListLength} displayRemoveButton={Boolean(sectinListLength > 1)} id={section.id} removeSection={removeSection} />
                                    </SectionProvider>
                                </div>
                            )}
                        />
                    </CustomPaper>
                </Box>

                <SimpleButtons
                    boxProps={{ sx: { '& .MuiButton-root': { position: 'relative' } } }}
                    extraChildren={(
                        <LoadingButton loading={!!loadings.modal} variant="outlined" onClick={() => { createQuestionnaire({ ignoreEdit: true, save: true, draft: true }) }}>{t('general.saveDraft')}</LoadingButton>
                    )}
                    accept={{
                        label: t('general.saveAndFinished'),
                        click: createQuestionnaire,
                    }}
                    cancel={{
                        label: t('general.addSection'),
                        click: addSection,
                        variant: 'text'
                    }}
                />
            </Box>
        </Box>
    )
}

export { Section }
